import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { LoadingController, AlertController } from "@ionic/angular";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { CsErrorText } from "../customer-search/customer-search.const";
import { switchAll } from "rxjs/operators";
import { errMsg } from "../../../text_control/error-msg";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage } from "src/app/utils/local-storage";

export interface Fruit {
  numbers: string;
}

@Component({
  selector: "app-customer-detail",
  templateUrl: "./customer-detail.component.html",
  styleUrls: ["./customer-detail.component.scss"],
})
export class CustomerDetailComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  response: any;
  body = {
    getcustomerbyid: "",
  };

  // sub_district = "";
  // distric = "";
  // province = "";
  // postcode = "";
  // district = "";
  phone: any = "";
  email = "";
  address_status = "1";
  buyer_type = "";
  selectedDevice = "";

  dataedit1 = [];
  dataedit: any = {};
  dataAddress: any;
  myparam: any;
  showbranch2 = true;
  buyer_branch_no: any = "";
  buyer_main_branch_no: any;
  radio_group = "";
  disable_buyer = false;
  buyer_agree_tmp = "";
  showbtn1 = false;
  showbtn2 = false;

  buyer_tax_id: any = "";
  buyer_tax_id1: any = "";
  actice: any;

  template_lang: any = "";

  zipcode: any;
  showfont1 = false;
  showfont2 = false;
  showfont3 = false;
  showfont4 = false;
  showbtn4 = true;
  showbranch = true;
  showAddr = true;
  loading = true;
  showLoading = true;
  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showTH = false;
  showEN = true;
  showEdit = true;
  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN = "";
  addrENOther = "";

  showOther = false;
  redioaddress = "1";
  emailEN = "";
  telEN = "";
  itemEN: any;
  show_taxid = false;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  isAddress = false;
  addressline1 = "";

  constructor(
    private route: Router,
    private fb: FormBuilder,
    private appService: AppService,
    private apiservice: ApiserviceService,
    private router: ActivatedRoute,
    public loadingController: LoadingController,
    public alertController: AlertController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text_addr = ADDRESS;
    this.text_btn = BTN;
    this.router.queryParams.subscribe((param) => {
      console.log(param["id"]);
      this.body.getcustomerbyid = param["id"];
    });
  }

  ngOnInit() {
    this.groupAddress = this.appService.address_thai;
    this.addressManual = false;
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });

    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
  }
  ionViewDidEnter() {
    this.loaddata();
    this.reloadcountry();
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.dataAddress.sub_district = item.district;
    this.dataAddress.district = item.amphoe;
    this.dataAddress.province = item.province;
    this.dataAddress.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.dataAddress.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.dataAddress.postcode = "";
    }
    if (name === "Province") {
      this.dataAddress.province = "";
    }
    if (name === "District") {
      this.dataAddress.district = "";
    }
    if (name === "SubDistrict") {
      this.dataAddress.sub_district = "";
    }
  }

  editdata() {
    this.showedit = false;
    this.showbtn3 = false;
    this.showAddr = false;
    this.showbtn4 = false;
    this.showbtn1 = true;
    this.showEdit = false;
    this.showbranch2 = this.radio_group === "0" ? true : false;
    if (this.itemEN.type_addr === "1") {
      this.redioaddress = "1";
      this.showTH = false;
      this.showEN = true;
    } else if (this.itemEN.type_addr === "2") {
      this.redioaddress = "2";
      this.showTH = true;
      this.showEN = false;
    }
  }
  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }
  reloadcountry() {
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }

  buyerDataValidate(response) {
    if (typeof response !== "object") {
      return { result: false, errmsg: CsErrorText.errDataValidation.th };
    }

    if (!response.hasOwnProperty("data")) {
      return { result: false, errmsg: CsErrorText.errDataValidation.th };
    }

    if (!response.hasOwnProperty("statusMessage")) {
      return { result: false, errmsg: CsErrorText.errDataValidation.th };
    }

    if (response.statusCode !== 200) {
      return { result: false, errmsg: response.statusMessage };
    }

    return { result: true, errmsg: "" };
  }

  cancelEdit() {
    this.showedit = true;
    this.showbtn1 = false;
    this.showbtn3 = true;
    this.showbtn4 = true;
    this.showbranch2 = true;
  }
  goBack() {
    this.route.navigate(["/customer-search"]);
  }
  async loaddata() {
    this.dataedit = null;
    this.showLoading = true;
    this.showedit = true;
    this.showbtn1 = false;
    this.showbtn3 = true;

    const response = await this.apiservice._post(
      this.apiservice.apiUrl + this.apiservice.getCustomerDetail,
      this.body
    );
    console.log("This is customer edit data", response);
    const valid = this.buyerDataValidate(response);
    try {
      if (!valid.result) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: valid.errmsg,
        });
        await alert.present();
        this.loading = false;
      } else {
        this.dataedit = response.data[0];

        this.buyer_branch_no = this.dataedit.buyer_branch_no;
        this.buyer_branch_no =
          this.dataedit.buyer_branch_no == "" ||
          this.dataedit.buyer_branch_no == "00000"
            ? ""
            : this.dataedit.buyer_branch_no;

        this.template_lang = this.dataedit.template_lang;

        this.buyer_type = String(this.dataedit.buyer_type);
        if (
          this.buyer_type === "0" ||
          this.buyer_type === "2" ||
          this.buyer_type === "3"
        ) {
          this.showbranch = false;
        } else {
          this.showbranch = true;
        }

        this.buyer_agree_tmp = this.dataedit.buyer_agree_tmp;

        this.radio_group =
          this.dataedit.buyer_branch_no == "" ||
          this.dataedit.buyer_branch_no == "00000"
            ? "0"
            : "1";
        if (this.dataedit.buyer_type === "0") {
          this.showfont1 = true;
          this.showfont2 = false;
          this.showfont3 = false;
          this.showfont4 = false;
          this.show_taxid = true;
          this.buyer_tax_id = this.dataedit.buyer_tax_id;
          this.buyer_tax_id1 = "";
        } else if (this.dataedit.buyer_type === "1") {
          this.showfont1 = false;
          this.showfont2 = true;
          this.showfont3 = false;
          this.showfont4 = false;
          this.show_taxid = true;
          this.buyer_tax_id = this.dataedit.buyer_tax_id;
          this.buyer_tax_id1 = "";
        } else if (this.dataedit.buyer_type === "2") {
          this.showfont1 = false;
          this.showfont2 = false;
          this.showfont3 = true;
          this.showfont4 = false;
          this.show_taxid = false;
          this.buyer_tax_id1 = this.dataedit.buyer_tax_id;
          this.buyer_tax_id = "";
        } else if (this.dataedit.buyer_type === "3") {
          this.showfont1 = false;
          this.showfont2 = false;
          this.showfont3 = false;
          this.showfont4 = true;
          this.show_taxid = false;
          this.buyer_tax_id1 = this.dataedit.buyer_tax_id;
          this.buyer_tax_id = "";
        }
        this.dataAddress = this.dataedit.address_detail[0];
        this.itemEN = this.dataedit.address_detail[0];

        this.isAddress = this.dataAddress.is_addresstxt;
        this.addressline1 = this.dataAddress.addressline1;
        this.dataAddress.sub_district = this.dataAddress.sub_district;
        this.dataAddress.district = this.dataAddress.district;
        this.dataAddress.province = this.dataAddress.province;
        this.dataAddress.postcode = this.dataAddress.postcode;
        if (this.itemEN.type_addr === "1") {
          this.redioaddress = "1";
          this.showTH = true;
          this.showEN = true;
        } else if (this.itemEN.type_addr === "2") {
          this.redioaddress = "2";
          this.showTH = true;
          this.showEN = true;
        }

        let country: any;

        country = this.dataCountry.filter(
          (i) => i.name === this.itemEN.inter_country
        );
        if (country.length > 0) {
          this.addrENCountry = country[0].name + ":" + country[0].code;
        }
        this.addrENPostCode = this.itemEN.inter_postcode;
        this.addrENProvince = this.itemEN.inter_province;
        this.addrEN = this.itemEN.inter_address_line1;
        this.emailEN = this.itemEN.email;
        this.telEN = this.itemEN.inter_tel;
        // ============ START ADDRESS EN ============//
        this.dataphone = this.dataAddress.phone.split(",");
        if (this.dataphone[0] === "") {
          this.dataphone = "";
        }

        this.fruits = [];
        for (let i of this.dataphone) {
          this.fruits.push({
            numbers: i,
          });
        }
        this.showLoading = false;
      }
    } catch (e) {
      this.loading = false;
    }
  }
  checkpostcode(e) {
    this.dataAddress.postcode = e.target.value.match(/[0-9]*/);
  }
  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkbranch1() {
    this.showbranch2 = true;
    this.buyer_branch_no = "";
  }
  checkbranch2() {
    this.showbranch2 = false;
    this.buyer_main_branch_no = "";
  }

  showedit = true;
  showbtn3 = true;
  showselect = true;
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  datasave: any;
  async confirmAlert() {
    let isConfirm: boolean = false;

    console.log("============= this.dataedit =============", this.dataedit);

    if (this.radio_group === "0") {
      this.buyer_main_branch_no = "00000";
    }

    let phones = [];

    for (let i of this.fruits) {
      phones.push(i.numbers);
    }

    this.appService.setActive(2);
    let data1 = this.dataedit.address_detail;
    for (let i = 0; i < data1.length; i++) {
      console.log(data1[i]);
      this.dataAddress = data1[i];
    }
    console.log("====== this.redioaddress ========", this.redioaddress);
    if (this.isAddress === true && this.addressline1 === "")
      return this.ErrorMsg(errMsg.errorAddressline1);

    if (this.isAddress === true && this.dataAddress.postcode === "") {
      return this.ErrorMsg(errMsg.postcode);
    }
    if (this.isAddress === true && this.dataedit.buyer_company_name === "") {
      return this.ErrorMsg(errMsg.buyer_company_name);
    }

    if (this.isAddress === false) {
      if (this.redioaddress === "1") {
        if (!isConfirm) {
          if (this.dataedit.buyer_company_name === "") {
            this.ErrorMsg(errMsg.buyer_company_name);
            return;
          }
          if (this.buyer_type === "2" && this.buyer_tax_id1.trim() === "") {
            this.ErrorMsg(errMsg.buyer_tax_id1);
            return;
          }
          if (
            this.buyer_type !== "2" &&
            this.buyer_type !== "3" &&
            this.buyer_tax_id === ""
          ) {
            this.ErrorMsg(errMsg.buyer_tax_id);
            return;
          }
          if (
            this.buyer_type !== "2" &&
            this.buyer_type !== "3" &&
            !this.appService.checkIdentityCardNumber(this.buyer_tax_id)
          ) {
            this.ErrorMsg(errMsg.card_tax);
            return;
          }

          if (this.radio_group === undefined) {
            this.ErrorMsg(errMsg.buyer_main_branch_no);
          } else if (this.radio_group === "1" && this.buyer_type === "1") {
            if (this.buyer_branch_no === "") {
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: "กรุณากรอกเลขที่สาขา",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.radio_group = "1";
                    },
                  },
                ],
              });
              await alert.present();
            } else if (this.dataAddress.house_no === "") {
              this.ErrorMsg(errMsg.house_no);
            } else if (this.dataAddress.postcode === "") {
              this.ErrorMsg(errMsg.postcode);
            } else if (this.dataAddress.district === undefined || this.dataAddress.district === "") {
              this.ErrorMsg(errMsg.district);
            } else if (
              this.dataAddress.sub_district === undefined ||
              this.dataAddress.sub_district === ""
            ) {
              this.ErrorMsg(errMsg.sub_district);
            } else if (this.dataAddress.province === undefined || this.dataAddress.province === "") {
              this.ErrorMsg(errMsg.province);
            } else if (this.dataAddress.email !== "") {
              const re =
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (!re.test(this.dataAddress.email)) {
                return this.ErrorMsg("รูปแบบ email ไม่ถูกต้อง");
              } else {
                isConfirm = true;
              }
            } else {
              isConfirm = true;
            }
          } else if (this.dataAddress.house_no === "") {
            this.ErrorMsg(errMsg.house_no);
          } else if (this.dataAddress.postcode === "") {
            this.ErrorMsg(errMsg.postcode);
          } else if (this.dataAddress.district === undefined || this.dataAddress.district === "") {
            this.ErrorMsg(errMsg.district);
          } else if (
            this.dataAddress.sub_district === undefined ||
            this.dataAddress.sub_district === ""
          ) {
            this.ErrorMsg(errMsg.sub_district);
          } else if (this.dataAddress.province === undefined || this.dataAddress.province === "") {
            this.ErrorMsg(errMsg.province);
          } else if (this.dataAddress.email !== "") {
            const re =
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(this.dataAddress.email)) {
              return this.ErrorMsg("รูปแบบ email ไม่ถูกต้อง");
            } else {
              isConfirm = true;
            }
          } else {
            isConfirm = true;
          }
        }
      } else {
        if (!isConfirm) {
          if (this.dataedit.buyer_company_name === "") {
            this.ErrorMsg(errMsg.buyer_company_name);
            return;
          }
          if (this.buyer_type === "2" && this.buyer_tax_id1 === "") {
            this.ErrorMsg(errMsg.buyer_tax_id1);
            return;
          }
          if (
            this.buyer_type !== "2" &&
            this.buyer_type !== "3" &&
            this.buyer_tax_id === ""
          ) {
            this.ErrorMsg(errMsg.buyer_tax_id);
            return;
          }
          if (
            this.buyer_type !== "2" &&
            this.buyer_type !== "3" &&
            !this.appService.checkIdentityCardNumber(this.buyer_tax_id)
          ) {
            this.ErrorMsg(errMsg.card_tax);
            return;
          }
          if (this.radio_group === undefined) {
            this.ErrorMsg(errMsg.buyer_main_branch_no);
          } else if (this.radio_group === "1" && this.buyer_type === "1") {
            if (this.buyer_branch_no === "") {
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: "กรุณากรอกเลขที่สาขา",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.radio_group = "1";
                    },
                  },
                ],
              });
              await alert.present();
            } else if (
              this.addrENProvince === "" ||
              this.addrENProvince === undefined
            ) {
              this.ErrorMsg(errMsg.addrENProvince);
            } else if (
              this.addrENPostCode === "" ||
              this.addrENPostCode === undefined
            ) {
              this.ErrorMsg(errMsg.addrENPostCode);
            } else if (
              this.addrENCountry === "" ||
              this.addrENCountry === undefined
            ) {
              this.ErrorMsg(errMsg.addrENCountry);
            } else if (this.dataAddress.email !== "") {
              const re =
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (!re.test(this.dataAddress.email)) {
                return this.ErrorMsg("รูปแบบ email ไม่ถูกต้อง");
              } else {
                isConfirm = true;
              }
            } else {
              isConfirm = true;
            }
          } else if (
            this.addrENProvince === "" ||
            this.addrENProvince === undefined
          ) {
            this.ErrorMsg(errMsg.addrENProvince);
          } else if (
            this.addrENPostCode === "" ||
            this.addrENPostCode === undefined
          ) {
            this.ErrorMsg(errMsg.addrENPostCode);
          } else if (
            this.addrENCountry === "" ||
            this.addrENCountry === undefined
          ) {
            this.ErrorMsg(errMsg.addrENCountry);
          } else if (this.dataAddress.email !== "") {
            const re =
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(this.dataAddress.email)) {
              return this.ErrorMsg("รูปแบบ email ไม่ถูกต้อง");
            } else {
              isConfirm = true;
            }
          } else {
            isConfirm = true;
          }
        }
      }
    } else {
      isConfirm = true;
    }
    if (isConfirm) {
      const data = {
        updateCustomerData: {
          buyer_id: this.dataedit.buyer_id,
          buyer_company_name: this.dataedit.buyer_company_name,
          buyer_people_id: null,
          buyer_main_branch_no:
            this.buyer_branch_no !== "" ? "" : this.buyer_main_branch_no,
          buyer_branch_no:
            this.buyer_branch_no === ""
              ? ""
              : this.buyer_branch_no.padStart(5, "0"),
          buyer_citizen_id: this.dataedit.buyer_citizen_id,
          buyer_tax_id:
            this.buyer_type === "2"
              ? this.buyer_tax_id1
              : this.buyer_type === "3"
              ? ""
              : this.buyer_tax_id,
          buyer_type: this.buyer_type,
          buyer_passpost_id: this.dataedit.buyer_passpost_id,
          buyer_agree_tmp: this.buyer_agree_tmp,
          user_id: this.userID,
          buyer_status: this.dataedit.buyer_status,
          template_lang: this.template_lang,
          address_detail: {
            addr_id: this.dataAddress.addr_id,
            building_no: this.dataAddress.building_no,
            building_name: this.dataAddress.building_name,
            room_no: this.dataAddress.room_no,
            floor: this.dataAddress.floor,
            house_no: this.dataAddress.house_no,
            village_no: this.dataAddress.village_no,
            lane: this.dataAddress.lane,
            road: this.dataAddress.road,
            sub_district: this.dataAddress.sub_district,
            district: this.dataAddress.district,
            province: this.dataAddress.province,
            postcode: String(this.dataAddress.postcode),
            phone: phones.join(","),
            email:
              this.dataAddress.type_addr === "1" ? this.dataAddress.email : this.emailEN,

            buyer_id: this.dataAddress.buyer_id,
            address_status: this.dataAddress.address_status,
            seller_id: this.dataAddress.seller_id,
            addr_agree_tmp: this.buyer_agree_tmp,
            user_id: this.userID,
            type_addr: this.redioaddress,
            inter_address_line1: this.addrEN,
            inter_country: this.addrENCountry,
            inter_fax: "",
            inter_postcode: this.addrENPostCode,
            inter_province: this.addrENProvince,
            inter_tel: this.telEN,
            is_addresstxt: this.isAddress,
            addressline1: this.addressline1 || "",
          },
        },
      };
      console.log("===== request update customer =======", data);

      try {
        this.apiservice
          ._post(this.apiservice.apiUrl + this.apiservice.editCustomer, data)
          .then(async (res: any) => {
            console.log("======== update customer =========: ", res);
            if (res.statusCode === 200) {
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                header: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.showEN = true;
                      this.showTH = true;
                      this.showbtn1 = false;
                      this.showfont3 = false;
                      this.showedit = true;
                      this.showbtn4 = true;
                      this.showAddr = true;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }
  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  dataphone: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  checkaddressTH() {
    this.template_lang = "TH";
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.template_lang = "EN";
    this.showTH = true;
    this.showEN = false;
  }

  checkaddrENOther() {
    this.showOther = this.addrENCountry !== "Other" ? false : true;
  }

  checkBuyerType(type) {
    console.log("[checkBuyerType] type of radio button : ", type);
    switch (type) {
      case "1":
        this.showfont1 = true;
        this.showfont2 = false;
        this.showfont3 = false;
        this.showfont4 = false;
        this.showbranch = false;
        this.showbtn1 = true;
        this.show_taxid = true;
        break;
      case "2":
        this.showfont1 = false;
        this.showfont2 = true;
        this.showfont3 = false;
        this.showfont4 = false;
        this.showbranch = true;
        this.showbtn2 = true;
        this.show_taxid = true;
        break;
      case "3":
        this.showfont1 = false;
        this.showfont2 = false;
        this.showfont3 = true;
        this.showfont4 = false;
        this.showbranch = false;
        this.showbtn3 = false;
        this.show_taxid = false;
        break;
      case "4":
        this.showfont1 = false;
        this.showfont2 = false;
        this.showfont3 = false;
        this.showfont4 = true;
        this.showbranch = false;
        this.showbtn3 = false;
        this.show_taxid = false;
        break;
    }
  }
  checkInpBranch(e) {
    this.buyer_branch_no = e.target.value.match(/[0-9]*/)[0];
  }

  checkTaxID(e) {
    this.buyer_tax_id = e.target.value.match(/[0-9]*/)[0];
  }
}
